var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7231 15.6109H20.6277C14.7939 15.6109 10.0431 10.8736 10.0431 5.05636V0H15.6308V5.08091C15.6308 7.83 17.8708 10.0391 20.6031 10.0391H25.6985V15.6109H25.7231Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2523 25.6504H11.4708V17.035L8.64 14.2122H0V11.4141H9.79692L14.2523 15.8813V25.6504Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlaceholder);
export default __webpack_public_path__ + "static/media/logo-placeholder.ef97e9cd59897b6c48bc857b10042ab2.svg";
export { ForwardRef as ReactComponent };